<template>
    <v-select
        :items="items"
        item-value="id"
        :item-text="item => $t(`base.${item.key}`)"
        :label="question[`label${upperLocale}`]"
        :rules="(question.required ? [requiredField()] : [])"
        @input="update($event)"
    />
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
export default {
    name: 'dynamic-drop-down-field',
    props: {
        question: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),
    },
    data: () => ({
        dynamicDropdownResponse: '',
        items: [{ id: '1', key: 'yes' }, { id: '0', key: 'no' }],
    }),
    mixins: [formRules],
    methods: {
        update(event) {
            this.$emit('updateQuestionResponse', { 'questionId': this.question.id, 'dynamicResponse': event });
        },
    },
};
</script>
